import ModalContainer from '@/components/molecules/ModalContainer';
import { background, text } from '@/theme/colors/palettes';
import { TTeamConcernCategory, TTeamConcernsRange } from '@/types/Organization.types';
import { HStack, Text, VStack } from '@chakra-ui/react';
import { useMemo } from 'react';
import ConcernRow from './ConcernRow';
import TeamConcernsLegend from './TeamConcernsLegend';
import TeamConcernsRangeSelect from './TeamConcernsRangeSelect';
import { ROW_GAP } from './helpers';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  categories: TTeamConcernCategory[];
  range: TTeamConcernsRange;
  onRangeChange: (range: TTeamConcernsRange) => void;
}

const TeamConcernsModal = ({ isOpen, onClose, categories, range, onRangeChange }: Props) => {
  const maxTotal = useMemo(() => Math.max(1, ...categories.map((r) => r.total)), [categories]);

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={onClose}
      backgroundColor={background.lightBlue}
      width={'730px'}
      maxWidth={'730px'}
      maxHeight={'90vh'}
      scrollOverflow
    >
      <VStack padding={'40px'} gap={'24px'} alignItems={'stretch'}>
        <Text variant={'loraMediumTitle'} textAlign={'center'} color={text.darkBlue}>
          All Internal Wholeness Notes
        </Text>

        <HStack width={'100%'} justifyContent={'space-between'} alignItems={'center'}>
          <TeamConcernsLegend />
          <TeamConcernsRangeSelect range={range} onChange={onRangeChange} />
        </HStack>

        <VStack width={'100%'} alignItems={'stretch'} gap={`${ROW_GAP}px`} marginTop={'4px'}>
          {categories.map((row) => (
            <ConcernRow key={row.category} row={row} maxTotal={maxTotal} totalPosition={'left'} />
          ))}
        </VStack>
      </VStack>
    </ModalContainer>
  );
};

export default TeamConcernsModal;
